import React from 'react'
import { connect } from 'react-redux'
import { AgGridReact } from 'ag-grid-react'

const Table = (props) => {
  const prepTableData = (data) => {
    return {
      columnDefs: [
        { headerName: 'id', field: 'id', editable: false, width: 100 },
        { headerName: 'name', field: 'name', editable: false, width: 100 },
        {
          headerName: 'properties',
          field: 'properties',
          editable: false,
          width: 700,
        },
      ],
      rowData: data,
    }
  }

  const { data, id } = props
  const tableData = prepTableData(data)
  return (
    <div className="mp-ag-grid" style={{ height: '100%', width: '100%' }}>
      <AgGridReact columnDefs={tableData.columnDefs} rowData={tableData.rowData}></AgGridReact>
    </div>
  )
}

const mapStateToProps = (state) => ({
  data: state.motassign.RulesEngine.Resources,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Table)
